/**
 * Centralized error logging for the frontend.
 * Use in catch blocks for consistent, structured error reporting.
 */
import loggingService from '../services/loggingService';

export const ErrorHandler = {
  /**
   * Log an error with context (for catch blocks).
   * @param {string} context - Where the error occurred (e.g. 'AuthContext - logout', 'GoogleSignInButton')
   * @param {Error} error - The error object
   * @param {Object} additionalData - Optional extra data to log
   */
  logError(context, error, additionalData = {}) {
    loggingService.error(`[${context}] Error`, {
      error,
      message: error?.message,
      stack: error?.stack,
      ...additionalData,
    });
  },

  logWarn(context, message, metadata = {}) {
    loggingService.warn(`[${context}] ${message}`, metadata);
  },
};

export default ErrorHandler;
